// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".status {\n  border: 1px solid transparent;\n  font-weight: bold;\n  font-size: 0.9rem;\n  margin-left: 18px;\n}\n", "",{"version":3,"sources":["webpack://src/views/MarketStatus/MarketStatus.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB","sourcesContent":[".status {\n  border: 1px solid transparent;\n  font-weight: bold;\n  font-size: 0.9rem;\n  margin-left: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
